<template>
  <tbody>
    <tr
      v-for="bid in auction.bids"
      :key="bid.index"
    >
      <td>
        {{ bid.index }}
      </td>
      <td>
        {{ bid.user.fullname }}
        <br>
        {{ bid.user.email }}
        <br>
        {{ bid.user.phone }}
      </td>
      <td>
        {{ manageDate({ date: bid.createdAt, format: 'DD.MM.YYYY' }) }}
        <br>
        {{ manageDate({ date: bid.createdAt, format: 'HH.MM' }) }}
      </td>
      <td>
        {{ I18n.t("artworks.price", { price: formatPrice(bid.value) }) }}
      </td>
      <td>
        <button
          v-if="!auction.lastOrder && bid.index === 1"
          class="btn-link"
          @click="modalVisibility = true"
        >
          {{ I18n.t("delete") }}
          <span class="icon-close-big ml-1" />
        </button>
      </td>
    </tr>
    <Modal
      v-if="modalVisibility"
      @close-modal="closeModal"
      :bid="auction.bids[0]"
    >
      <template slot="approveBtn">
        <button
          type="button"
          class="btn btn-secondary mr-3"
          @click="removeBid"
        >
          {{ I18n.t("simple_form.yes") }}
        </button>
      </template>
      <template slot="disapproveBtn">
        <button
          type="button"
          class="btn btn-secondary"
          @click="closeModal"
        >
          {{ I18n.t("simple_form.no") }}
        </button>
      </template>
    </Modal>
  </tbody>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { formatNumber } from '@/shared/helpers';
  import ManageDate from '@/shared/mixins/manage_date';
  import Modal from './../modal';

  export default {
    name: 'BidsTableBody',
    components: {
      Modal,
    },
    mixins: [ManageDate],
    props: {
      auction: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        modalVisibility: false,
        formatPrice: formatNumber,
      };
    },
    computed: {
      ...mapGetters(['bidsCount']),
    },
    methods: {
      ...mapActions([
        'deleteBid',
        'fetchAuctionsBids',
      ]),
      removeBid() {
        this.deleteBid({
          internetAuctionId: this.auction.id,
          bidId: this.auction.bids[0].id,
        });
        this.closeModal();
      },
      closeModal() {
        this.modalVisibility = false;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees_orders_panel/components/table/bids_table_body.vue?6d3d12a4